<template>
  <v-container fluid>
    <v-btn text @click="$router.back()">
      <v-icon left class="px-2">mdi-arrow-left</v-icon>
      {{ $t("back") }}
    </v-btn>

    <h2 class="font-weight-bold my-4">
      {{ $t("change_password") }}
    </h2>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            v-model="form.old_password"
            :label="$t('old_password')"
            :rules="[rules.required]"
            :type="showOldPassword ? 'text' : 'password'"
            required
            outlined
            dense
            :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showOldPassword = !showOldPassword"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="form.new_password"
            :label="$t('new_password')"
            :rules="[rules.required, rules.minLength]"
            :type="showNewPassword ? 'text' : 'password'"
            required
            outlined
            dense
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showNewPassword = !showNewPassword"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="form.confirm_password"
            :label="$t('confirm_password')"
            :rules="[rules.required, rules.passwordMatch]"
            :type="showConfirmPassword ? 'text' : 'password'"
            required
            outlined
            dense
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showConfirmPassword = !showConfirmPassword"
          />
        </v-col>

        <v-col cols="12">
          <v-btn 
            color="amber darken-2"
            :disabled="!valid" 
            :loading="loading"
            @click="submitForm"
          >
            {{ $t("change_password") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import api from "../services/axios";

export default {
  data() {
    return {
      valid: false,
      loading: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      form: {
        old_password: "",
        new_password: "",
        confirm_password: ""
      },
      rules: {
        required: (v) => !!v || this.$t("field_required"),
        minLength: (v) => 
          (v && v.length >= 8) || this.$t("password_min_length"),
        passwordMatch: (v) => 
          v === this.form.new_password || this.$t("passwords_not_match")
      }
    };
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      
      const formData = new FormData();
      formData.append("old_password", this.form.old_password);
      formData.append("new_password", this.form.new_password);
      formData.append("confirm_password", this.form.confirm_password);

      try {
        const res = await api.post("user/password-change", formData, {
          headers: {
            "Accept": "application/json",
            "Accept-Language": this.$i18n.locale
          }
        });

        this.$root.$emit("show-snackbar", {
          message: res.data.message,
          color: res.data.status ? "success" : "error"
        });
      } catch (error) {
        console.error(error);
        this.$root.$emit("show-snackbar", {
          message: error.response?.data?.message || this.$t("change_password_failed"),
          color: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>